export default __webpack_public_path__ + "b39457c9cd60669e6f2c788e122a59e1.png";